var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-background",attrs:{"data-section":"2"}},[_c('canvas',{ref:"canvas",style:(_vm.canvasStyles),attrs:{"width":"1920","height":"1080"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }